import { CurrencyCode } from 'further-types/lp/vehicle';
import { round, sumBy } from 'lodash';
import {
  FooterCell,
  FooterContainer,
  HeaderCell,
  StyledHeader,
  StyledRow,
  StyledTable,
} from 'components/TableComponents/TableComponents';
import { styled, TableBody, TableCell, TableRow } from '@mui/material';
import { numberToCurrencyString } from 'further-ui/utils';
import { InvestorAllocationTotals } from '../../types';

type Props = {
  currency: CurrencyCode;
  investorAllocationsTotals: Array<InvestorAllocationTotals>;
};

const DarkTableCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: theme.palette.background.darkTableCell,
  fontWeight: theme.typography.fontWeightBold,
}));

const DarkFooterCell = styled(FooterCell)(({ theme }) => ({
  backgroundColor: theme.palette.background.darkTableCell,
}));

const TotalsTable: React.FC<Props> = ({
  currency,
  investorAllocationsTotals,
}) => {
  return (
    <StyledTable
      isTotalsTable
      hasBorderTopRightRadius
      hasBorderBottomRightRadius
      hasMinWidth={false}
    >
      <StyledHeader>
        <StyledRow>
          <HeaderCell isHeader paddingSize="md">
            Total consideration
          </HeaderCell>
        </StyledRow>
      </StyledHeader>
      <TableBody>
        {investorAllocationsTotals.map(({ commitmentId, total }) => (
          <StyledRow key={commitmentId}>
            <DarkTableCell>
              {numberToCurrencyString(total, {
                currency,
              })}
            </DarkTableCell>
          </StyledRow>
        ))}
      </TableBody>
      <FooterContainer>
        <TableRow>
          <DarkFooterCell paddingSize="sm">
            {numberToCurrencyString(
              round(sumBy(investorAllocationsTotals, 'total'), 2),
              {
                currency,
              },
            )}
          </DarkFooterCell>
        </TableRow>
      </FooterContainer>
    </StyledTable>
  );
};

export default TotalsTable;
